import { makeFupIcon } from './FupIconFactory';
export default makeFupIcon('PID');
